window.initChatbox = function () {
    const chatBox = document.getElementById('chatbox');

    if (chatBox) {
        if (!window.chatBoxScript) {
            let script = window.chatBoxScript = document.createElement('script');
            script.src = '/dist/js/marked.min.js';
            script.defer = true;
            script.async = true;
            document.head.appendChild(script);
        }
        if (!window.chatBoxScriptTwo) {
            let scriptTwo = window.chatBoxScriptTwo = document.createElement('script');
            scriptTwo.src = '/dist/js/purify.min.js';
            scriptTwo.defer = true;
            scriptTwo.async = true;
            document.head.appendChild(scriptTwo);
        }

        const api = chatBox.dataset.api;
        const referralId = chatBox.dataset.referralId;

        // Check if the chatbox is enabled for the listing
        fetch(api + '/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                query: `
                    query Property($referral: String) {
                      property(referral: $referral) {
                        id
                        chat_enabled
                        referral
                        status {
                          activated
                          marketable
                          sold
                        }
                      }
                    }
                `,
                variables: {
                    referral: referralId
                },
            })
        }).then(async response => {
            const data = await response.json();
            if (data.data.property !== null &&
                data.data.property.status.marketable === true &&
                data.data.property.status.sold === false &&
                data.data.property.chat_enabled === true) {
                // if all is good, we show the chatbox
                chatBox.classList.remove('hidden--imp');
                chatbox();
            } else {
                chatBox.parentElement.remove();
            }
        }).catch(err => {
            console.error(err);
            chatBox.parentElement.remove();
        });

    }
}

window.chatbox = function () {
    const chatBox = document.getElementById('chatbox');

    // When chatBox is loaded, we initialise the event listeners and fetch requests
    if (chatBox !== null) {
        const cbInterface = document.getElementById('chatbox-interface');
        const cbForm = document.getElementById('chatbox-form');
        const cbInput = document.getElementById('chatbox-form-input');
        const cbSubmit = document.getElementById('chatbox-form-submit');
        const cbResult = document.getElementById('chatbox-answer');
        let cbClose = document.getElementById('chatbox-answer-close');

        const cbOverlay = document.getElementById('chatbox-overlay');
        const cbOverlayContent = document.getElementById('chatbox-overlay-content');
        const cbOverlayClose = document.getElementById('chatbox-overlay-close');
        const cbOverlayAccept = document.getElementById('chatbox-overlay-accept');
        const cbOverlayExpireTime = Date.now() + (30 * 864e5); // 30 days. 864e5 represents 1 day in milliseconds

        const cbFeedback = document.getElementById('chatbox-feedback');
        const cbFeedbackButtons = document.getElementById('chatbox-feedback-buttons');
        const cbFeedbackThumbsUp = document.getElementById('chatbox-feedback-thumbs-up');
        const cbFeedbackThumbsDown = document.getElementById('chatbox-feedback-thumbs-down');
        const cbFeedbackThanks = document.getElementById('chatbox-feedback-thanks');
        const cbFeedbackReply = document.getElementById('chatbox-feedback-reply');
        const cbFeedbackInput = document.getElementById('chatbox-feedback-input');
        const cbFeedbackSubmit = document.getElementById('chatbox-feedback-submit');

        const referralId = chatBox.dataset.referralId;
        const api = chatBox.dataset.api;
        let cbFeedbackId = null;
        let responseUnmodifiedBuffer = '';
        let timeout = null;
        let timeoutSeconds = 5;
        let intervalId = null;
        let isRequestInProgress = false;
        let questionCounter = 0;

        if (cbInterface && cbInput && cbResult && cbClose && cbOverlay && cbOverlayContent && cbOverlayClose && cbOverlayAccept) {
            // Initialize a new TextDecoder instance
            const decoder = new TextDecoder('utf-8');

            const askChatGPT = () => {
                if (cbInput.value !== '' && cbInput.value.length > 3 && !isRequestInProgress) {
                    // Remove and reset feedback elements
                    resetFeedback();

                    isRequestInProgress = true;
                    cbResult.innerHTML =
                        '<div id="chatbox-answer-avatar">' +
                            '<div>' +
                                '<img src="/img/aia-eie.jpg" alt="Aia Eie profilbilde">' +
                                '<span>Vent mens jeg søker etter svaret på spørsmålet ditt...<span class="loader"></span></span>' +
                            '</div>' +
                            '<button id="chatbox-answer-close">x</button>' +
                        '</div>';

                    setupCloseButton();

                    // Increment the counter each time the function is called
                    questionCounter++;

                    fetch(api + '/api/v2/property/' + referralId + '/ask', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify({
                            q: cbInput.value,
                        })
                    }).then(async response => {
                        cbSubmit.textContent = 'Mottar...';
                        // Read the response as a stream
                        const reader = response.body.getReader();
                        // Initialize variables to hold the chunks of data and the paragraphs of the response.
                        let buffer = '';
                        let paragraphs = [''];
                        // need an unmodified buffer to send to feedback until we have the DB ID of the chat entry.
                        responseUnmodifiedBuffer = '';
                        // Read the stream and decode the chunks of data and append them to the buffer
                        while (true) {
                            const { done, value } = await reader.read();
                            if (done) break;
                            let chunk = decoder.decode(value, {stream: true});
                            buffer += chunk;
                            responseUnmodifiedBuffer += chunk;
                            let newlineIndex;
                            // Check if the buffer contains a newline character, if so, split the buffer at the newline
                            // character, sanitize and parse the line before the newline and add it to the last element
                            // of the paragraphs array. Then remove the line from the buffer and add an empty string to
                            // the paragraphs array.
                            while ((newlineIndex = buffer.indexOf('\n')) !== -1) {
                                let line = buffer.slice(0, newlineIndex);
                                buffer = buffer.slice(newlineIndex + 1);
                                paragraphs[paragraphs.length - 1] = DOMPurify.sanitize(marked.parse(line));
                                paragraphs.push('');
                            }
                            // After the inner loop, the remaining buffer is added to the last element of the paragraphs array.
                            paragraphs[paragraphs.length - 1] = buffer;
                            cbResult.innerHTML = paragraphs.join('');

                            cbResult.innerHTML = '<div id="chatbox-answer-avatar" class="answer">' +
                                    '<img src="/img/aia-eie.jpg" alt="Aia Eie profilbilde">' +
                                '</div>' +
                                '<button id="chatbox-answer-close">x</button>' +
                                paragraphs.join('');

                            setupCloseButton();
                        }
                        // If the buffer is not empty after the outer loop, sanitize and parse the remaining buffer and
                        // add it to the last element of the paragraphs array.
                        if (buffer.length > 0) {
                            paragraphs[paragraphs.length - 1] = DOMPurify.sanitize(marked.parse(buffer));
                            cbResult.innerHTML = '<div id="chatbox-answer-avatar" class="answer">' +
                                    '<img src="/img/aia-eie.jpg" alt="Aia Eie profilbilde">' +
                                '</div>' +
                                '<button id="chatbox-answer-close">x</button>' +
                                paragraphs.join('');

                            setupCloseButton();
                        }
                    }).catch(err => {
                        console.error(err);
                        cbResult.textContent = `Det skjedde dessverre en feil under søket. Prøv igjen senere.`;
                    }).finally(() => {
                        isRequestInProgress = false;
                        cbSubmit.removeAttribute('disabled');
                        cbSubmit.textContent = 'Send';
                        // comment out if feedback doesn't work in the backend
                        cbFeedback.classList.add('active');
                        // on every third question, remind the user that the responses can be wrong
                        if (questionCounter % 3 === 0) {
                            cbResult.innerHTML += '<p class="italic">Husk at jeg kan gi ufullstendige svar og gjøre feil, at jeg ikke kan foreta skjønnsmessige og/eller rettslige vurderinger, og at opplysningene jeg gir <span class="underline">ikke</span> er tilstrekkelig til å inngi bud eller inngå avtale om kjøp. Som interessent/budgiver er du selv ansvarlig for å gjøre deg kjent med opplysningene om boligen som gis i salgsdokumentene slik som bla. tilstandsrapport, salgsoppgave og egenerklæring.</p>';
                        }
                    });
                }
            }

            const sendFeedback = (positive = false) => {
                if (!isRequestInProgress) {
                    isRequestInProgress = true;

                    fetch(api + '/api/v2/property/' + referralId + '/feedback', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify({
                            thumb: positive ? 1 : 2,
                            feedback: cbFeedbackInput.value,
                            chat: responseUnmodifiedBuffer,
                        })
                    }).then(async response => {
                        if (cbFeedbackInput.value.length > 0) {
                            cbFeedbackSubmit.textContent = 'Mottar...';
                        }
                        const data = await response.json();

                        if (data.message !== "Chat evaluated successfully") {
                            cbFeedbackThanks.textContent = 'Det skjedde en feil under tilbakemeldingen. Prøv på nytt.';
                            cbFeedbackThanks.classList.add('active');
                            cbFeedbackSubmit.textContent = 'Send';
                            cbFeedbackInput.removeAttribute('disabled');
                            cbFeedbackSubmit.removeAttribute('disabled');
                        } else {
                            if (!positive && cbFeedbackInput.value.length < 1) {
                                cbFeedbackThanks.textContent = 'Takk for tilbakemeldingen! Hjelp oss å forbedre tjenesten med å forklare hva som ikke var bra.';
                                cbFeedbackInput.value = '';
                                cbFeedbackInput.removeAttribute('disabled');
                                cbFeedbackSubmit.removeAttribute('disabled');
                                cbFeedbackThanks.classList.add('active');
                                cbFeedbackReply.classList.add('active');
                            } else {
                                if (cbFeedbackInput.value.length > 0) {
                                    cbFeedbackButtons.classList.add('hidden');
                                }
                                cbFeedbackThanks.textContent = 'Takk for tilbakemeldingen!';
                                cbFeedbackThanks.classList.add('active');
                                cbFeedbackReply.classList.remove('active');
                                cbFeedbackInput.value = '';
                                cbFeedbackInput.setAttribute('disabled', 'disabled');
                                cbFeedbackSubmit.textContent = 'Send';
                                cbFeedbackSubmit.setAttribute('disabled', 'disabled');
                            }
                        }
                    }).catch(err => {
                        console.error(err);
                        cbFeedbackThanks.textContent = 'Det skjedde en feil under tilbakemeldingen. Prøv på nytt.';
                        cbFeedbackThanks.classList.add('active');
                    }).finally(() => {
                        isRequestInProgress = false;
                    });
                }
            }

            const resetFeedback = (keepButtons = false) => {
                if (!keepButtons) {
                    cbFeedback.classList.remove('active');
                }
                cbFeedbackButtons.classList.remove('hidden');
                cbFeedbackThumbsDown.classList.remove('active');
                cbFeedbackThumbsUp.classList.remove('active');
                cbFeedbackReply.classList.remove('active');
                cbFeedbackThanks.classList.remove('active');
                cbFeedbackThanks.textContent = 'Takk for tilbakemeldingen!';

                cbFeedbackInput.value = '';
                cbFeedbackInput.removeAttribute('disabled');
                cbFeedbackSubmit.textContent = 'Send';
                cbFeedbackSubmit.removeAttribute('disabled');
            }

            const closeChatbox = (event) => {
                isRequestInProgress = false;
                clearTimeout(timeout);
                clearInterval(intervalId);
                cbInput.blur();
                cbInterface.classList.remove('active');
                cbSubmit.textContent = 'Send';
                cbSubmit.removeAttribute('disabled');
                cbInput.value = '';
                cbResult.innerHTML =
                    '<div id="chatbox-answer-avatar">' +
                        '<div>' +
                            '<img src="/img/aia-eie.jpg" alt="Aia Eie profilbilde">' +
                            '<span>Hei! Jeg er AIA, vår virtuelle meglerassistent ✨</span>' +
                        '</div>' +
                        '<button id="chatbox-answer-close">x</button>' +
                    '</div>' +
                    '<p>Spør meg om det du lurer på, og jeg skal forsøke å finne svarene for deg.</p>' +
                    '<p>Du kan bruke et naturlig språk, og stille spørsmål som:</p>' +
                    '<ul>' +
                    '<li>"Hvordan er utsikten?"</li>' +
                    '<li>"Er det noe i tilstandsrapporten jeg bør merke meg?"</li>' +
                    '</ul>';

                setupCloseButton();
                // Remove and reset feedback elements
                resetFeedback();
            };

            const openChatbox = () => {
                cbInterface.classList.add('active');

                if (localStorage.getItem('chatboxAccept') && +localStorage.getItem('chatboxAccept') > Date.now()) {
                    cbOverlay.remove();
                } else {
                    setTimeout(() => {
                        if (cbOverlayContent.scrollHeight > cbOverlayContent.clientHeight) {
                            cbOverlayContent.addEventListener('scroll', function () {
                                // Check if user has scrolled to the bottom
                                if (cbOverlayContent.scrollTop + cbOverlayContent.clientHeight >= cbOverlayContent.scrollHeight - 5) {
                                    // User has scrolled to the bottom, enable the accept button
                                    cbOverlayAccept.disabled = false;
                                }
                            });
                        } else {
                            cbOverlayAccept.disabled = false;
                        }
                    }, 1500);

                    cbOverlayAccept.addEventListener('click', function () {
                        // Save a state in the local storage if accepted
                        localStorage.setItem('chatboxAccept', cbOverlayExpireTime.toString());
                        cbOverlay.remove();
                    });
                }
            }

            function setupCloseButton() {
                setTimeout(function(){
                    cbClose = document.getElementById('chatbox-answer-close');
                    if (cbClose) {
                        cbClose.addEventListener('pointerdown', closeChatbox, false);
                    }
                }, 100);
            }

            // Chatbox close buttons event listeners
            setupCloseButton();
            cbOverlayClose.addEventListener('pointerdown', closeChatbox, false);
            // Chatbox open button event listener
            cbForm.addEventListener('pointerdown', openChatbox, false);

            // Chatbox keyboard "enter" event listener
            cbInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    clearTimeout(timeout);
                    clearInterval(intervalId);
                    cbSubmit.textContent = 'Sender...';
                    cbSubmit.setAttribute('disabled', 'disabled');
                    askChatGPT();
                }
                if (event.key === 'Escape') {
                    closeChatbox();
                }
            }, false);
            // Chatbox button submit event listener
            cbSubmit.addEventListener('click', (event) => {
                clearTimeout(timeout);
                clearInterval(intervalId);
                cbSubmit.textContent = 'Sender...';
                cbSubmit.setAttribute('disabled', 'disabled');
                askChatGPT();
            }, false);

            // chatbox input typing event listener
            cbInput.addEventListener('input', (event) => {
                // clear the timeout and interval
                clearTimeout(timeout);
                clearInterval(intervalId);
                cbSubmit.textContent = 'Send';
                // if the input is more than 3 characters, enable the submit button and start a countdown
                if (event.target.value.length > 3) {
                    cbSubmit.removeAttribute('disabled');
                    let countdown = timeoutSeconds - 1;
                    intervalId = setInterval(() => {
                        if (countdown > 0) {
                            cbSubmit.textContent = countdown.toString();
                            countdown--;
                        } else {
                            clearInterval(intervalId);
                            cbSubmit.textContent = 'Sender...';
                            cbSubmit.setAttribute('disabled', 'disabled');
                        }
                    }, 1000);
                } else {
                    cbSubmit.setAttribute('disabled', 'disabled');
                    cbSubmit.textContent = 'Send';
                }
                // set a timeout to ask the question after 3 seconds of inactivity
                timeout = setTimeout(() => {
                    askChatGPT();
                }, timeoutSeconds * 1000);
            });

            // ChatboxFeedback thumbs up event listener
            cbFeedbackThumbsUp.addEventListener('click', () => {
                // Remove and reset feedback elements
                resetFeedback(true);
                // Add active class to thumbs up and send feedback
                cbFeedbackThumbsUp.classList.add('active');
                sendFeedback(true);
            });
            // ChatboxFeedback thumbs down event listener
            cbFeedbackThumbsDown.addEventListener('click', () => {
                // Remove and reset feedback elements
                resetFeedback(true);
                // Add active class to thumbs down and enable the feedback input
                cbFeedbackThumbsDown.classList.add('active');
                sendFeedback(false);
            });

            // ChatboxFeedback keyboard "enter" event listener
            cbFeedbackInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    cbFeedbackInput.setAttribute('disabled', 'disabled');
                    cbFeedbackSubmit.textContent = 'Sender...';
                    cbFeedbackSubmit.setAttribute('disabled', 'disabled');
                    sendFeedback(false);
                }
            }, false);
            // ChatboxFeedback button submit event listener
            cbFeedbackSubmit.addEventListener('click', (event) => {
                cbFeedbackInput.setAttribute('disabled', 'disabled');
                cbFeedbackSubmit.textContent = 'Sender...';
                cbFeedbackSubmit.setAttribute('disabled', 'disabled');
                sendFeedback(false);
            }, false);

            // If query argument handling=chatbox is present, open the chatbox
            if (window.location.search.includes('handling=spor-om-boligen')) {
                setTimeout(function(){
                    openChatbox();
                    cbInput.focus();
                }, 500);
            }
        }
    }
}

/** get in call stack **/
setTimeout(function() {
    initChatbox();
}, 100 );
